<p>help-mws-finances-checklist works!</p>
